var _rect, _rect2, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "flags / TR"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    y: 0.666992,
    width: 32,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23455_6791",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask_2",
    y: 0.666992,
    width: 32,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23455_6791)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask Copy",
    y: 0.666992,
    width: 32,
    height: 20,
    fill: "#E92434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7379 11.4357L20.3381 12.9207L20.4335 10.9975L18.3868 10.2916L20.5066 9.77662L20.6415 7.85531L21.8562 9.46019L23.9862 8.97875L22.6172 10.4855L23.7987 12.1093L21.7379 11.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.889 14.3511C18.6342 15.7605 16.6762 16.667 14.4763 16.667C10.6892 16.667 7.61914 13.9807 7.61914 10.667C7.61914 7.35328 10.6892 4.66699 14.4763 4.66699C16.6762 4.66699 18.6342 5.57349 19.889 6.98288C18.9207 6.36711 17.7033 6.00033 16.381 6.00033C13.2251 6.00033 10.6668 8.08966 10.6668 10.667C10.6668 13.2443 13.2251 15.3337 16.381 15.3337C17.7033 15.3337 18.9207 14.9669 19.889 14.3511Z",
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/TR.157e7c794b8862a24b9345a98e51917f.svg";
export { ForwardRef as ReactComponent };